import { Navigate, useLocation } from 'react-router-dom';
import { FullPageSpinner } from '@/components/common';
import { ROUTES } from '@/config';
import { useAuth } from '@/hooks';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Dashboard access: system/tenant admins plus users with `canAccessDashboard`. */
  requireAdmin?: boolean;
  /** System or tenant admin only, for pages whose whole API is admin-gated. */
  requireAdminRole?: boolean;
}

export function ProtectedRoute({
  children,
  requireAdmin = false,
  requireAdminRole = false,
}: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, canAccessDashboard, isAdmin } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <FullPageSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (requireAdmin && !canAccessDashboard) {
    return <Navigate to={ROUTES.WORKER} replace />;
  }

  if (requireAdminRole && !isAdmin) {
    return <Navigate to={ROUTES.ADMIN_TASKS} replace />;
  }

  return <>{children}</>;
}
